import React, { createContext, useContext, useState } from 'react'
import { Tab, Tabs } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import '../../components/rooftopsComponent/menu/menu.css'

export const SAP_DIRECT_BUILDERS = [
    { key: 'fancoils', label: 'Fancoils' },
    { key: 'drycooler', label: 'Dry Cooler' },
    { key: 'cdu', label: 'CDU' },
]

const NavigationContext = createContext({ disabled: false, setDisabled: () => {} })
export const useSapDirectNavigation = () => useContext(NavigationContext)

export function SapDirectNavigationProvider({ children }) {
    const [disabled, setDisabled] = useState(false)
    return <NavigationContext.Provider value={{ disabled, setDisabled }}>{children}</NavigationContext.Provider>
}

export default function SapDirectNavigation() {
    const { pathname } = useLocation()
    const { disabled } = useSapDirectNavigation()
    const index = SAP_DIRECT_BUILDERS.findIndex(({ key }) => pathname === `/sap-direct/${key}`)
    return (
        <Tabs className='rooftop' aria-label='SAP Direct builders' value={index < 0 ? 0 : index}>
            {SAP_DIRECT_BUILDERS.map(({ key, label }) => (
                <Tab key={key} className='tab' label={label} component={NavLink} to={`/sap-direct/${key}`} disabled={disabled} />
            ))}
        </Tabs>
    )
}
